/** Format seconds for the admin QR refresh text field. */
export function formatQrRefreshIntervalInput(totalSeconds: number): string {
  const sec = Number.isFinite(totalSeconds) ? Math.max(0, Math.floor(totalSeconds)) : 0;
  return String(sec);
}

/**
 * Parse admin QR refresh input as whole seconds.
 * Empty / invalid → 0 (no refresh).
 */
export function parseQrRefreshIntervalInput(raw: string): number {
  const trimmed = (raw || '').trim();
  if (!trimmed) return 0;
  const n = Number.parseInt(trimmed, 10);
  if (!Number.isFinite(n) || n < 0) return 0;
  return n;
}
